module.exports = __webpack_public_path__ + "img/by.719d4486.svg";